import React, { FC, useEffect, useState } from "react";
import { useLoginContext } from "context/login-context";
import { checkValid } from "utils/check-password";
import { useResetPasswordContext } from "context/reset-password-context";
import * as S from "../style";

interface InputProps {
  passwordData: string;
  fieldName: any;
  label: String;
  error: boolean;
}

const CustomResetPasswordInput: FC<InputProps> = ({ error, fieldName, label, passwordData, }) => {
  const {
    password,
    setPassword,
    setValidation,
  } = useResetPasswordContext();

  const { isLoading } = useLoginContext();
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const isShowPassword = passwordData.length > 0 && !showPassword
  const isHidePassword = passwordData.length > 0 && showPassword

  const changePassword = (campo, valor) => {
    setPassword({
      ...password,
      [campo]: valor,
    });
  };

  const onChange = (event) => {
    if (fieldName === 'newPass') {
      const validationObject = checkValid(event.target.value);
      setValidation(validationObject);
    }
    changePassword(fieldName, event.target.value);
  }

  useEffect(() => {
    if (fieldName === 'newPass' && !passwordData) {
      setValidation({});
    }
  }, [fieldName, passwordData]);

  return (
    <S.ContainerPasswordStyled>
      <S.PasswordInput
        id={`password-reset-input-${fieldName}`}
        label={label}
        type={showPassword ? 'text' : 'password'}
        fullWidth
        InputProps={{
          disableUnderline: true,
        }}
        onChange={onChange}
        disabled={isLoading}
        value={passwordData}
        error={error}
      />
      {isShowPassword ?
        <S.ContainerEyeStyled onClick={() => setShowPassword(true)}>
          Mostrar
        </S.ContainerEyeStyled>
        : isHidePassword ?
          <S.ContainerEyeStyled onClick={() => setShowPassword(false)}>
            Ocultar
          </S.ContainerEyeStyled>
          : null
      }
    </S.ContainerPasswordStyled>
  )
}

export default CustomResetPasswordInput;